// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "4cf5f6799aa888f32ca122d468a23c7c" + ".js";
};